import { SVGProps } from '@components/Icon/types';

export const Billable = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M10.042 4.5C10.4299 4.5 10.7217 4.79908 10.7217 5.19727V5.89355C11.7396 5.94349 12.4184 6.54128 12.6123 6.88965C12.8059 7.18829 12.7087 7.63596 12.418 7.83496C12.1271 8.03388 11.691 7.9343 11.4971 7.63574C11.4971 7.63574 11.2062 7.28726 10.5762 7.28711H9.50879C8.97557 7.28728 8.49121 7.73583 8.49121 8.33301C8.4914 8.92999 8.92725 9.37777 9.50879 9.37793H10.6729C11.9817 9.378 12.9998 10.4727 13 11.7666C13 13.0607 11.9334 14.1064 10.6729 14.1064V14.8027C10.6729 15.2009 10.3819 15.4999 9.99414 15.5C9.60626 15.5 9.31543 15.2009 9.31543 14.8027V14.1064C8.49119 14.1064 7.71497 13.8072 7.18164 13.21C6.93956 12.961 6.93937 12.5134 7.18164 12.2646C7.42406 12.0158 7.86109 12.0158 8.10352 12.2646C8.29752 12.4637 8.68533 12.7627 9.31543 12.7627H10.624C11.1574 12.7627 11.6426 12.3141 11.6426 11.7168C11.6424 11.1197 11.2057 10.6719 10.624 10.6719H9.50879C8.19997 10.6717 7.18183 9.57706 7.18164 8.2832C7.18164 7.03898 8.15132 5.99327 9.36328 5.89355V5.19727C9.36328 4.79922 9.65433 4.50022 10.042 4.5Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.40039C5.25035 1.40039 1.40039 5.25035 1.40039 10C1.40039 14.7496 5.25035 18.5996 10 18.5996C14.7496 18.5996 18.5996 14.7496 18.5996 10C18.5996 5.25035 14.7496 1.40039 10 1.40039Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'billable';
